import React from 'react';
import GpyComponent from './GpyComponent'
import GpyKeybindingButton from './GpyKeybindingButton.js';

class GpyScoreButton extends GpyComponent {
  constructor(props) {
      super(props);

      this.state = {
            gpyComponentID: super.getId(),
            connected: false,
            score : 0,
            min: this.props.min!==undefined?this.props.min:0,
            max: this.props.max!==undefined?this.props.max:100000,
            type: this.props.scoreType!==undefined?this.props.scoreType:"std",
      };
    }

    onChangeValue(o){
      if ( o.score !== undefined ) {
            var s = parseInt(o.score,10);
            this.setState({score: s});
            var obj = {};
            obj[this.props.stateName] = s;
            super.sendGameState(obj);
      }
    }

    getScore() {
      return this.state.score;
    }

    setScore(s,callback){

      if(this.state.type === 'std') {
        if(s < this.state.min) {
          s = this.state.min;
        }
        if(s > this.state.max) {
          s = this.state.max;
        }
      }
      if(this.state.type === 'ring') {
        if(s < this.state.min) {
          s = this.state.max;
        }
        if(s > this.state.max) {
          s = this.state.min;
        }
      }

      this.setState({score:s}, ()=>{
         if(this.props.onChangeScore!==undefined) {
          this.props.onChangeScore(s);
         }
         if(callback!==undefined) callback();
       }
      );

      var obj = {};
      obj[this.props.stateName] = JSON.stringify({score:s,value:s,gpyComponentID:this.state.gpyComponentID});
      obj['#TIME'] = this.props.getTime!==undefined?this.props.getTime():0;
      obj['#GAMEID'] = this.props.getGameId!==undefined?this.props.getGameId():-1;
      super.sendGameState(obj);



    }

    componentDidMount(){
      if(this.props.scoreboard !== undefined ){
         this.props.scoreboard.registerComponent(this.props.stateName,this);
      };
      if(this.props.scoreboard.state !== undefined && this.props.stateName !== undefined && this.props.scoreboard.state[this.props.stateName] !== undefined && this.props.scoreboard.state[this.props.stateName].score !== undefined) {
        this.setState({score : parseInt(this.props.scoreboard.state[this.props.stateName].score,10) });
      }
    }

    decrementScore(value = 1) {
      var s = parseInt(this.state.score,10) - value;
      if(this.state.type === 'std') {
        if(s < this.state.min) {
          s = this.state.min;
        }
        if(s > this.state.max) {
          s = this.state.max;
        }
      }
      if(this.state.type === 'ring') {
        if(s < this.state.min) {
          s = this.state.max;
        }
        if(s > this.state.max) {
          s = this.state.min;
        }

      }
      this.setState({score:s},() => { if(this.props.onChangeScore!==undefined) this.props.onChangeScore(s) });

      var obj = {};
      obj[this.props.stateName] = JSON.stringify({score:s,value:s,gpyComponentID:this.state.gpyComponentID});
      obj['#TIME'] = this.props.getTime!==undefined?this.props.getTime():0;
      obj['#GAMEID'] = this.props.getGameId!==undefined?this.props.getGameId():-1;
      super.sendGameState(obj);
    }

    incrementScore(value=1) {
      var s = parseInt(this.state.score,10) + value;

      if(this.state.type === 'std') {
        if(s < this.state.min) {
          s = this.state.min;
        }
        if(s > this.state.max) {
          s = this.state.max;
        }
      }
      if(this.state.type === 'ring') {
        if(s < this.state.min) {
          s = this.state.max;
        }
        if(s > this.state.max) {
          s = this.state.min;
        }
      }
      this.setState({score:s},() => { if(this.props.onChangeScore!==undefined) this.props.onChangeScore(s) });

      var obj = {};
      obj[this.props.stateName] = JSON.stringify({score:s,value:s,gpyComponentID:this.state.gpyComponentID});
      obj['#TIME'] = this.props.getTime!==undefined?this.props.getTime():0;
      obj['#GAMEID'] = this.props.getGameId!==undefined?this.props.getGameId():-1;
      super.sendGameState(obj);
    }

    onData(key,data){
      if(data.gpyComponentID !== this.state.gpyComponentID) {
        this.setState({score : data.score});
      }
    }

  render() {
    const {score,type} = this.state;
    var disabled = function(i){
      if(type === 'ring') {
        return false;
      }

      if(score === i) {
        return true;
      }
      return false;
    }
		return (
        <div className="row p-1" style={{zIndex:100}}>
            <div className="col-4 p-0">

            {disabled(this.state.min)?
              <GpyKeybindingButton scoreboard={this.props.scoreboard} title={"-"}
              stateName={this.props.stateName+"_MINUS"}
              disabled={true}
              className="btn btn-sm btn-secondary"/>
            :
              <GpyKeybindingButton scoreboard={this.props.scoreboard} title={"-"}
              stateName={this.props.stateName+"_MINUS"}
              onClick={()=>this.decrementScore()}
              className="btn btn-sm btn-secondary"/>
            }
            </div>
            <div className="col-4 text-center"><span className="">{score}</span></div>
            <div className="col-4 p-0 text-right ">

            {disabled(this.state.max)?
            <GpyKeybindingButton scoreboard={this.props.scoreboard} title={"+"}
              stateName={this.props.stateName+"_PLUS"}
              disabled={true}
              className="btn btn-sm btn-secondary"
              />
            : <GpyKeybindingButton scoreboard={this.props.scoreboard} title={"+"}
              stateName={this.props.stateName+"_PLUS"}
              onClick={()=>this.incrementScore()}
              className="btn btn-sm btn-secondary"
              />}

              </div>
        </div>
		)
  }
}
export default GpyScoreButton;
